import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { CitiesDataService, CitiesColumnsService } from '../../../services';
import { City, CitiesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-city-details',
  templateUrl: './city-details.component.html',
  styleUrls: ['./city-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class CityDetailsComponent implements OnInit, OnDestroy {

  public city: City = {};
  public cities: City[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private citiesDataService: CitiesDataService,
    private citiesColumnsService: CitiesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('City - Details');
        this.getCity(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.city !== 'undefined') {
      this.city = this.dynamicDialogConfig.data.city;
    }
    this.columns = this.citiesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getCity(id: number): void {
    this.isLoading = true;
    this.citiesDataService.getCity(id).subscribe((response: City|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.city = response;
      }
    });
  }

  list() {
    this.router.navigate(['/cities']);
  }

  add() {
    this.router.navigate(['/cities/add']);
  }

  edit() {
    this.router.navigate(['/cities/edit/' + this.city.id]);
  }

}
@Component({
  selector: 'app-city-details',
  templateUrl: './city-details.component.html',
  styleUrls: ['./city-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogCityDetailsComponent extends CityDetailsComponent {
}

